import { Pipe, PipeTransform } from '@angular/core';
import { BrandService } from '../../../core/brand';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'brandAsset'
})
export class BrandAssetPipe implements PipeTransform {
  constructor(private brandService: BrandService) {}

  transform(assetRelativePath: string): Observable<string> {
    const brandDirectory = this.brandService.brand;
    return brandDirectory.pipe(
      map((brand) => {
        const directory = brand.replace(/_/g, '-');
        return `assets/${directory}/${assetRelativePath}`;
      })
    );
  }
}
